import { render } from "./COIActionBar.vue?vue&type=template&id=c33fd85a"
import script from "./COIActionBar.vue?vue&type=script&lang=js"
export * from "./COIActionBar.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__